import { motion } from "framer-motion";
import { X, Check } from "lucide-react";

const otherTools = [
  "Generic templates sent to everyone",
  "Sounds robotic after 2 messages",
  "Self-setup takes days of frustration",
  "Same AI for every business",
  "You're on your own after signup",
];

const appointext = [
  "Custom built around your business",
  "Sounds exactly like you",
  "Done for you — live in 3 to 7 days",
  "Built from scratch per client",
  "We handle everything start to finish",
];

export default function DifferentiatorSection() {
  return (
    <section data-testid="differentiator-section" className="py-24 md:py-32 relative">
      {/* Accent glow */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at center, rgba(59, 130, 246, 0.04) 0%, transparent 60%)" }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-14 md:mb-16"
        >
          <h2
            data-testid="differentiator-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-4"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            The difference between AppoinText and everything else.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {/* Other Tools */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            data-testid="other-tools-column"
            className="bg-zinc-900/30 border border-white/[0.06] rounded-2xl p-7 md:p-8"
          >
            <p className="text-zinc-500 text-sm font-semibold uppercase tracking-wider mb-6">Other AI Tools</p>
            <ul className="space-y-4">
              {otherTools.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-zinc-400 text-sm leading-relaxed">
                  <X size={16} className="text-zinc-600 mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          {/* AppoinText */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            data-testid="appointext-column"
            className="bg-zinc-900 border-2 border-blue-500/30 rounded-2xl p-7 md:p-8 shadow-[0_0_40px_rgba(59,130,246,0.06)]"
          >
            <p className="text-blue-400 text-sm font-semibold uppercase tracking-wider mb-6">AppoinText</p>
            <ul className="space-y-4">
              {appointext.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-zinc-200 text-sm leading-relaxed">
                  <Check size={16} className="text-blue-400 mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="text-center text-zinc-300 text-lg font-semibold mt-12"
          style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
          It's not a tool you buy. It's an AI we build for you.
        </motion.p>
      </div>
    </section>
  );
}
